module.exports = __webpack_public_path__ + "static/media/21.74df0087.jpg";